import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { serialize } from 'object-to-formdata'
import { RequestParams, ResponseCatalog } from 'Models'
import { BusinessappsModel, CreateBusinessappsModel } from 'Pages/orders'

export const businessappsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BusinessappsModel>>(urls.orders.businessapps, {
			params,
		})
		return res.data
	},

	getOne: async (id: string) => {
		const res = await axiosDS().get<BusinessappsModel>(`${urls.orders.businessapps}/${id}`)
		return res.data
	},

	createOne: async (data: CreateBusinessappsModel) => {
		const dataForm = serialize({ data })
		if (data?.attachment_attributes) {
			dataForm.delete('data[attachment_attributes]')
			dataForm.append('data[attachment_attributes][file]', data?.attachment_attributes)
		}
		const res = await axiosDS().post<BusinessappsModel>(urls.orders.businessapps, dataForm)
		return res.data
	},

	updateOne: async (id: string, data: CreateBusinessappsModel) => {
		if (!data?.attachment_attributes?.type) delete data?.attachment_attributes
		const dataForm = serialize({ data })
		if (data?.attachment_attributes) {
			dataForm.delete('data[attachment_attributes]')
			dataForm.append('data[attachment_attributes][file]', data?.attachment_attributes)
		}
		const res = await axiosDS().patch<BusinessappsModel>(
			`${urls.orders.businessapps}/${id}`,
			dataForm
		)
		return res.data
	},

	deleteOne: async (id: string) => {
		await axiosDS().delete(`${urls.orders.businessapps}/${id}`)
	},

	deleteFile: async (id: number, filename: string) => {
		const res = await axiosDS().delete(
			urls.orders.attachment.replace(':id', id.toString()).replace(':filename', filename)
		)
		return res.data
	},
}
